module.exports = __webpack_public_path__ + "img/humberger-menu.22fc8bcd.svg";